import React from 'react';
import { CommandItem } from '@/components/ui/command';
import { Loader2, Navigation } from 'lucide-react';

interface CurrentLocationItemProps {
  onSelect: () => void;
  geolocating: boolean;
}

export const CurrentLocationItem: React.FC<CurrentLocationItemProps> = ({
  onSelect,
  geolocating
}) => {
  return (
    <CommandItem 
      onSelect={onSelect}
      disabled={geolocating}
      className="cursor-pointer"
    >
      {geolocating ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          <span>Getting your location...</span>
        </>
      ) : (
        <>
          <Navigation className="h-4 w-4 mr-2 text-blue-500" />
          <span>Use my current location</span>
        </>
      )}
    </CommandItem>
  );
};